import { render, staticRenderFns } from "./peopleAttributeAge.vue?vue&type=template&id=3673c58e"
import script from "./peopleAttributeAge.vue?vue&type=script&lang=js"
export * from "./peopleAttributeAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports